const isBrowser = typeof window !== 'undefined';

const protocol = isBrowser ? window.location.protocol : 'http:';
const host = isBrowser ? window.location.host : 'localhost:5468';
const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:';

const apiUrl = isBrowser ? `${protocol}//${host}` : 'http://localhost:5468';
const socketUrl = isBrowser ? `${wsProtocol}//${host}/ws` : 'ws://localhost:5468/ws';

export { socketUrl, apiUrl };
